import React, { useState, useRef } from 'react';
import DownArrow from '../../static/dashboard/downarrow.svg';
import UpArrow from '../../static/dashboard/uparrow.svg';

import '../../styles/dropdown/Dropdown.css';

export default function Dropdown({ items, handleChange, errorText, loading }) {
    const [active, setActive] = useState(false);
    const [value, setValue] = useState("Select a listing");
    const [clickedItem, setClickedItem] = useState(false);
    const ref = useRef(null);

    return (
        <div className="Dropdown">
            <div 
            className={`select ${errorText ? 'form-error-input' : ''}`}
            onClick={(e) => {
                if (!loading) {
                    setTimeout(() => {
                        if (!active) {
                            ref.current.classList.add("overflow"); // This was to make it that the overflow bar only shows after load entire list.
                                                                   // Probably can remove if this effect isn't necessary, or update so it doesn't
                                                                   // use a specific timeout.
                        }
                    }, 450);
                    setActive(!active);
                    setClickedItem(false);
                }
            }}>
                <span>{value}</span>
                <img src={active ? UpArrow : DownArrow} alt="Down" />
            </div>
            {errorText && <p className="form-error">{errorText}</p>}
            <ul 
            ref={ref}
            className={`items ${active ? 'active' : ''} ${clickedItem ? 'clickedItem' : ''}`}>
            {
                items.map((item) => 
                <li
                className={value === item ? 'selected' : ''}
                onClick={(e) => {
                    if (!(value === item)) {
                        setActive(false);
                        setValue(item);
                        setClickedItem(true);
                        handleChange(item);
                    }

                }}>{item}</li>)
            }
            </ul>
        </div>
    )
}